import { SHIFTS } from "@/constants/shifts";

/**
 * Segment "Sve / Sm. 1 / Sm. 2 …" i naslov tamne kartice sa zbirom.
 * Komponenta daje prop `shifts` i computed `shiftTotals` ({ [shiftId]: broj }).
 */
export default {
  computed: {
    /** Smene 1–3 uvek, četvrta samo kad ima obroka. */
    visibleShifts() {
      return SHIFTS.filter((shift) => shift.id < 4 || this.shiftTotals[shift.id] > 0);
    },
    isSingleShift() {
      return this.shifts.length === 1;
    },
    segments() {
      return [
        {
          key: "all",
          label: this.$t("report_mobile.all"),
          shifts: SHIFTS.map((shift) => shift.id),
          active: !this.isSingleShift,
        },
        ...this.visibleShifts.map((shift) => ({
          key: shift.id,
          label: this.$t("report_mobile.shift_short", { n: shift.id }),
          shifts: [shift.id],
          active: this.isSingleShift && this.shifts[0] === shift.id,
        })),
      ];
    },
    summaryLabel() {
      if (this.isSingleShift) {
        return this.$t("report_mobile.total_meals_shift", { n: this.shifts[0] });
      }
      if (this.shifts.length === SHIFTS.length) {
        return this.$t("report_mobile.total_meals_all_shifts");
      }
      return this.$t("report_mobile.total_meals_shifts", { list: this.shifts.join(", ") });
    },
  },
};
